// extracted by mini-css-extract-plugin
module.exports = {"actionButtonsContainer":"ReferralSources_actionButtonsContainer__1RKsK","actionColumn":"ReferralSources_actionColumn__26JQS","textButton":"ReferralSources_textButton__-qkGb"};